import { combineReducers } from 'redux';
import { qrCodeEntitiesReducer } from 'redux/reducers/qr-codes/qr-codes.entities';
import { qrCodeIdsReducer } from 'redux/reducers/qr-codes/qr-codes.ids';

export const qrCodesReducer = combineReducers({
  ids: qrCodeIdsReducer,
  entities: qrCodeEntitiesReducer,
});
